import React from "react";
import { useTranslation } from "react-i18next";


function HomeBanner() {
  const { i18n, t } = useTranslation();
  return (
    <section className="home-banner">
      <div className="row align-items-center gx-5">
        {/* <div className="col-12 col-lg-5 text-center">
          <img
            src="/images/webp/home-banner.webp"
            className="img-fluid"
            alt=""
          />
        </div> */}
        <div className="col-12 text-center">
          <h2>  {t("home:home-banner:title", "Roma inclusion strategic documents")}</h2>
          <p>  {t("home:home-banner:description", "The implementation of the Roma Inclusion Strategic Documents in the Western Balkans is guided by the principles and standards set by both the European Union and the Council of Europe. These strategic frameworks ensure that national policies align with the EU and CoE overarching goals of human rights, equality, and social inclusion, as well as the recommendations for the protection and integration of minority groups, particularly the Roma. The documents focus on addressing the persistent challenges of discrimination, poverty, and marginalisation faced by Roma communities, with specific actions in key areas such as education, employment, healthcare, housing, and social services.")}</p>
          <p> {t("home:home-banner:summary", "This approach is directly linked to the EU enlargement process and the commitments made at the Poznań and Berlin Summits to improve the conditions of Roma communities and support their social inclusion. This ensures that the benefits of the enlargement process are felt by all, fostering more inclusive, cohesive, and rights-respecting societies across the region.")}</p>
        </div>
      </div>
    </section>
  );
}

export default HomeBanner;
